import * as React from "react";
import * as Helpers from "../helpers";
import { StepWizardChildProps } from "react-step-wizard";
import InputOptions from "../Components/InputOptions";
import InputText from "../Components/InputText";
import PageNavigation from "../Components/PageNavigation";
import Steps from "./steps";

export type ScheduleFields = {
    schedule_frequency: "Weekly" | "Fortnightly" | "Other";
    schedule_frequency_other: string;
    schedule_time_required: string;
    schedule_cleaner_day: "Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Flexible";
    schedule_cleaner_backup: "Mon" | "Tue" | "Wed" | "Thu" | "Flexible";
    schedule_cleaner_time: "AM" | "PM" | "Flexible";
}

export class Schedule extends React.Component<PageProps<ScheduleFields> & Partial<StepWizardChildProps>, PageState> {
    constructor(props: PageProps<ScheduleFields>) {
        super(props);

        this.state = {
            validation_triggered: false
        };
    }

    triggerValidation()
    {
        const page_fields = ["schedule_frequency", "schedule_time_required", "schedule_cleaner_day", "schedule_cleaner_time"];

        if (this.props.form_values.schedule_frequency === "Other") {
            page_fields.push("schedule_frequency_other")
        }

        if (this.props.form_values.schedule_cleaner_day === "Fri") {
            page_fields.push("schedule_cleaner_backup")
        }

        return Helpers.TriggerValidation(this, page_fields, this.props.required, this.props.form_values);
    }

    goBack() {
        if (this.props.previousStep) {
            this.props.previousStep();
        }
    }

    submit() {
        const validation_result = this.triggerValidation();
        if (!validation_result) {
            return;
        }

        if (this.props.nextStep) {
            this.props.nextStep();
        }
    }

    render() {
        let scrolled = false;
        let getScrolled = () => scrolled;
        let setScrolled = () => { scrolled = true; };

        return <div>
            <InputOptions
                label="How often would you like a cleaner?"
                name="schedule_frequency"
                additional_classes="landing-schedule-options"
                options={[
                    { label: "Weekly", value: "Weekly", details: <ul>
                            <li>Same dedicated cleaner</li>
                            <li>Account manager</li>
                            <li>Insured + more</li>
                            <li>{this.props.franchise_details.WeeklyHourlyRate}</li>
                        </ul> },
                    { label: "Fortnightly", value: "Fortnightly", details: <ul>
                            <li>Same dedicated cleaner</li>
                            <li>Account manager</li>
                            <li>Insured + more</li>
                            <li>{this.props.franchise_details.FortnightlyHourlyRate}</li>
                        </ul> },
                    { label: "Other", value: "Other", details: <ul>
                            <li>Let us know what you need</li>
                        </ul> }
                ]}
                is_exclusive={true}
                equal_labels={true}
                value={this.props.form_values.schedule_frequency}
                required={this.props.required.schedule_frequency}
                validation_triggered={this.state.validation_triggered}
                validation_get_scrolled={getScrolled}
                validation_set_scrolled={setScrolled}
                update_value={this.props.update_value}
            />
            {this.props.form_values.schedule_frequency === "Other" ?
                <InputText
                    label="Please provide details about the clean you require"
                    type="textarea"
                    rows={4}
                    name="schedule_frequency_other"
                    value={this.props.form_values.schedule_frequency_other}
                    required={this.props.required.schedule_frequency_other}
                    validation_message="Please provide details about the clean you require"
                    validation_triggered={this.state.validation_triggered}
                    validation_get_scrolled={getScrolled}
                    validation_set_scrolled={setScrolled}
                    update_value={this.props.update_value}
                />
            : null}

            <InputText
                label="How long do you need a cleaner?"
                type="range"
                min={2}
                max={20}
                step={0.5}
                valueSuffix="hours"
                name="schedule_time_required"
                value={this.props.form_values.schedule_time_required}
                required={this.props.required.schedule_time_required}
                validation_triggered={this.state.validation_triggered}
                validation_get_scrolled={getScrolled}
                validation_set_scrolled={setScrolled}
                update_value={this.props.update_value}
            />

            <InputOptions label="Preferred day"
                name="schedule_cleaner_day"
                value={this.props.form_values.schedule_cleaner_day}
                required={this.props.required.schedule_cleaner_day}
                validation_triggered={this.state.validation_triggered}
                validation_get_scrolled={getScrolled}
                validation_set_scrolled={setScrolled}
                update_value={this.props.update_value}
                options={[
                    { label: "Mon", value: "Mon" },
                    { label: "Tue", value: "Tue" },
                    { label: "Wed", value: "Wed" },
                    { label: "Thu", value: "Thu" },
                    { label: "Fri", value: "Fri" },
                    { label: "Flexible", value: "Flexible" }
                ]}
                is_exclusive={true}
            />

            {this.props.form_values.schedule_cleaner_day === "Fri" ?
                <InputOptions label="Due to Fridays being extremely busy, please select a suitable back up day"
                    name="schedule_cleaner_backup"
                    value={this.props.form_values.schedule_cleaner_backup}
                    required={this.props.required.schedule_cleaner_backup}
                    validation_triggered={this.state.validation_triggered}
                    validation_get_scrolled={getScrolled}
                    validation_set_scrolled={setScrolled}
                    update_value={this.props.update_value}
                    options={[
                      { label: "Mon", value: "Mon" },
                      { label: "Tue", value: "Tue" },
                      { label: "Wed", value: "Wed" },
                      { label: "Thu", value: "Thu" },
                      { label: "Fri", value: "Fri" },
                      { label: "Flexible", value: "Flexible" }
                    ]}
                    is_exclusive={true}
                /> : null}

            <InputOptions label="Preferred time(s)"
                name="schedule_cleaner_time"
                value={this.props.form_values.schedule_cleaner_time}
                required={this.props.required.schedule_cleaner_time}
                validation_triggered={this.state.validation_triggered}
                validation_get_scrolled={getScrolled}
                validation_set_scrolled={setScrolled}
                update_value={this.props.update_value}
                options={[
                  { label: "AM", value: "AM" },
                  { label: "PM", value: "PM" },
                  { label: "Flexible", value: "Flexible" }
                ]}
                is_exclusive={true}
            />

            <div className="row">
                <div className="col-md-6">
                    <Steps totalSteps={this.props.totalSteps!} currentStep={this.props.currentStep!} />
                </div>
                <div className="col-md-6">
                    <PageNavigation allowPrevious={true} allowNext={true} useSubmitForNext={false} onNext={() => this.submit()} onPrevious={() => this.goBack()} />
                </div>
            </div>
        </div>;
    }
}